if (!customElements.get('cart-notification')) {

  class CartNotification extends HTMLElement {
    constructor() {
      super();

      this.notification = document.getElementById("cart-notification");
      this.header = document.querySelector("sticky-header");
      this.onBodyClick = this.handleBodyClick.bind(this);

      this.cartTimer = this.notification.querySelector('cart-timer');

      this.notification.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.close()
      );
      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener("click", this.close.bind(this))
      );

      this.showTrustProgramm();
    }

    open() {
      this.notification.classList.add("animate", "active");

      this.notification.addEventListener(
        "transitionend",
        () => {
          this.notification.focus();
          trapFocus(this.notification);
        },
        { once: true }
      );
      document.body.addEventListener("click", this.onBodyClick);
    }

    close() {
      this.notification.classList.remove("active");

      document.body.removeEventListener("click", this.onBodyClick);
      this.notification.querySelector("#cart-notification-product-upsell").innerHTML = "";
      removeTrapFocus(this.activeElement);
    }

    renderContents(parsedState) {
      this.cartItemKey = (parsedState.items) ? parsedState.items[0].key : parsedState.key;
      this.cartItemUpsellKey = (parsedState.items) ? parsedState.items[1].key : null;

      this.getSectionsToRender().forEach((section) => {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[(section.sectionId) ? section.sectionId : section.id],
          section.selector
        );
      });

      if (this.cartTimer) this.cartTimer.productAddedToCart();
      this.open();
    }

    getSectionsToRender() {
      const sections = [
        {
          id: "cart-notification-product",
          selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
        },
        {
          id: "cart-notification-upsell",
        },
        {
          id: "cart-notification-button",
        },
        {
          id: "cart-icon-bubble",
        },
        {
          id: "cart-notification-progress",
          selector: "#cart-notification-progress"
        }
      ];

      if (this.cartItemUpsellKey) {
        sections.push({
          id: "cart-notification-product-upsell",
          sectionId: "cart-notification-product",
          selector: `[id="cart-notification-product-${this.cartItemUpsellKey}"]`,
        });
      }

      return sections;
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target !== this.notification && !target.closest("cart-notification")) {
        const disclosure = target.closest("details-disclosure, header-menu");
        this.activeElement = disclosure
          ? disclosure.querySelector("summary")
          : null;
        this.close();
      }
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    showTrustProgramm() {
      if (document.querySelector("[data-customer-digest]")) {
        const { customerDigest, customerEmail, customerId, shop } = document.querySelector("[data-customer-digest]").dataset;
        const params = new URLSearchParams({
          customer_id: customerId,
          customer_email: customerEmail,
          shop,
          digest: customerDigest
        })

        fetch(`https://launcher.api.influence.io/launcher/v1/shop/rules/redeem?shop=inno-nature.myshopify.com`)
          .then((response) => response.json())
          .then(({ rules }) => {
            const allRules = rules.sort((a, b) => a.pointCost - b.pointCost);
            fetch(`https://launcher.api.influence.io/launcher/v1/customer?${params}`)
              .then((response) => response.json())
              .then((json) => {
                console.log(json.pointBalance);
                const rule = allRules.find(rule =>  json.pointBalance < rule.pointCost);
                if(rule){
                  const missingPoints = rule.pointCost - json.pointBalance;
                  document.querySelector("#cart-notification-benefits").innerHTML = `Dir fehlen noch ${missingPoints} Punkte für ${rule.customTitle}`;
                }
              });
          });


      }
    }
  }

  customElements.define("cart-notification", CartNotification);

}

if (!customElements.get('cart-upsell-notification')) {
  class CartUpsellNotification extends HTMLElement {
    constructor() {
      super();
      this.addUpsellButton = this.querySelector("button");
      this.addUpsellButton.addEventListener("click", this.addUpsell.bind(this));
      this.cartNotification = document.querySelector("cart-notification");
    }

    enableLoadingButton() {
      this.addUpsellButton.setAttribute("aria-disabled", true);
      this.addUpsellButton.classList.add("loading");

      this.querySelectorAll(".loading-overlay__spinner").forEach(
        (spinner) => {
          spinner.classList.remove("hidden");
        }
      );
    }

    disableLoadingButton() {
      this.addUpsellButton.setAttribute("aria-disabled", false);
      this.addUpsellButton.classList.remove("loading");

      this.querySelectorAll(".loading-overlay__spinner").forEach(
        (spinner) => {
          spinner.classList.add("hidden");
        }
      );
    }

    addUpsell(e) {
      e.preventDefault();
      this.enableLoadingButton();
  
      /* Start customizations "enhanced-datalayer" */
      /* we need to send default formData like in product-form.js to get a more rich response */
      /* seems like a bug from Shopify, because based on the content-type of the request the result is differently */
      const config = fetchConfig("javascript");
      const formData = new FormData();
  
      const { id } = this.addUpsellButton.dataset;
      formData.append("id", id);
      formData.append("quantity", 1);
      formData.append("sections", this.cartNotification.getSectionsToRender().map((section) => section.id).join(","));
      formData.append("sections_url", window.location.pathname);
      
      config.body = formData;
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      /* End customizations "enhanced-datalayer" */
  
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.cartNotification.renderContents(response);
          this.disableLoadingButton();
        })
        .catch(() => {
          document.getElementById("cart-errors").textContent =
            window.cartStrings.error;
        });

    }
  }
  customElements.define("cart-upsell-notification", CartUpsellNotification);

}